/* ============================================================
   XYLA THEME — shared behaviour
   Load once in theme.liquid (before </body>):
   <script src="{{ 'xyla-base.js' | asset_url }}" defer></script>
   ============================================================ */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- reveal on scroll + counters ---------- */
  function initReveal(root) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        var c = e.target.querySelector('[data-count]');
        if (c && !c.dataset.done) count(c);
        io.unobserve(e.target);
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
    (root || document).querySelectorAll('.reveal,[data-io],.xyla-pillar__media,.xyla-inside__media').forEach(function (el) { io.observe(el); });
  }

  function count(el) {
    el.dataset.done = 1;
    var to = parseFloat(el.dataset.count) || 0;
    if (reduce || to === 0) { el.textContent = to; return; }
    var t0 = null;
    (function step(t) {
      if (!t0) t0 = t || performance.now();
      var p = Math.min(((t || performance.now()) - t0) / 1200, 1);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(to * e);
      if (p < 1) requestAnimationFrame(step);
    })();
  }

  /* ---------- bass comparison ---------- */
  function initBass(section) {
    var LO = parseFloat(section.dataset.axisLo) || 30;
    var HI = parseFloat(section.dataset.axisHi) || 300;
    function x(f) { return (Math.log10(f) - Math.log10(LO)) / (Math.log10(HI) - Math.log10(LO)) * 100; }

    var cutTpl = section.dataset.cutLabel || '[hz] Hz limit';
    var chart = section.querySelector('[data-bass-chart]');
    var noteEl = section.querySelector('[data-bass-note]');
    var buttons = section.querySelectorAll('[data-cut]');
    if (!chart || !buttons.length) return;

    /* build bars from row data — all critical styles inline so theme CSS cannot override them */
    var rows = chart.querySelectorAll('.xyla-bass__row');
    var barBase = 'display:block;position:absolute;top:0;bottom:0;border-radius:4px;pointer-events:none;';
    var lostBg = 'background:repeating-linear-gradient(135deg,rgba(247,245,241,.16) 0 4px,transparent 4px 9px);';
    var liveBg = 'background:linear-gradient(90deg,#a8683a,rgba(168,104,58,.55));transition:clip-path 1s cubic-bezier(.2,.7,.2,1);';
    rows.forEach(function (row) {
      var tr = row.querySelector('.xyla-bass__track');
      var lo = parseFloat(tr.dataset.lo), hi = parseFloat(tr.dataset.hi);
      if (isNaN(lo)) lo = LO; if (isNaN(hi)) hi = Math.min(HI, 100);
      lo = Math.max(lo, LO); hi = Math.min(hi, HI);
      tr.dataset.lo = lo; tr.dataset.hi = hi;
      tr.style.position = 'relative';
      if (!tr.offsetHeight) tr.style.height = '26px';
      tr.style.overflow = 'hidden';
      tr.innerHTML =
        '<div class="xyla-bass__bar lost" style="' + barBase + lostBg + 'left:' + x(lo) + '%;width:' + (x(hi) - x(lo)) + '%"></div>' +
        '<div class="xyla-bass__bar live" style="' + barBase + liveBg + 'left:' + x(lo) + '%;width:' + (x(hi) - x(lo)) + '%"></div>';
    });

    /* axis ticks + labels */
    var axis = section.querySelector('[data-bass-axis]');
    if (axis) {
      var ticks = [LO, 40, 60, 100, 200, HI].filter(function (f, i, a) { return f >= LO && f <= HI && a.indexOf(f) === i; });
      var svg = '<svg viewBox="0 0 100 12" preserveAspectRatio="none">';
      ticks.forEach(function (f) { svg += '<line x1="' + x(f) + '" y1="0" x2="' + x(f) + '" y2="8" vector-effect="non-scaling-stroke"/>'; });
      svg += '</svg><div class="xyla-bass__axislabels">';
      ticks.forEach(function (f, i) {
        if (i === ticks.length - 1) { svg += '<span style="left:auto;right:0;transform:none">' + f + '&nbsp;Hz</span>'; }
        else { svg += '<span style="left:' + x(f) + '%">' + f + '</span>'; }
      });
      svg += '</div>';
      axis.innerHTML = svg;
    }

    var cutline = document.createElement('div'); cutline.className = 'xyla-bass__cutline';
    cutline.style.cssText = 'display:block;position:absolute;top:-6px;bottom:28px;width:1px;background:#f7f5f1;opacity:.9;transition:left 1s cubic-bezier(.2,.7,.2,1);';
    var cutlab = document.createElement('div'); cutlab.className = 'xyla-bass__cutlab';
    cutlab.style.cssText = 'position:absolute;top:-30px;transform:translateX(-50%);white-space:nowrap;transition:left 1s cubic-bezier(.2,.7,.2,1);';
    chart.style.position = 'relative';
    chart.appendChild(cutline); chart.appendChild(cutlab);
    var firstTrack = chart.querySelector('.xyla-bass__track');

    function setCut(cut, noteHtml) {
      buttons.forEach(function (b) { b.setAttribute('aria-pressed', String(parseFloat(b.dataset.cut) === cut)); });
      var chartRect = chart.getBoundingClientRect();
      var trackRect = firstTrack.getBoundingClientRect();
      var px = (trackRect.left - chartRect.left) + trackRect.width * x(cut) / 100;
      cutline.style.left = px + 'px';
      cutlab.style.left = px + 'px';
      cutlab.textContent = cutTpl.replace('[hz]', cut).replace('{hz}', cut);
      chart.querySelectorAll('.xyla-bass__track').forEach(function (tr) {
        var lo = parseFloat(tr.dataset.lo), hi = parseFloat(tr.dataset.hi);
        if (isNaN(lo)) lo = LO; if (isNaN(hi)) hi = Math.min(HI, 100);
        var live = tr.querySelector('.live');
        if (hi <= cut) { live.style.clipPath = 'inset(0 100% 0 0)'; return; }
        var from = Math.max(lo, cut);
        var pct = (x(from) - x(lo)) / (x(hi) - x(lo)) * 100;
        live.style.clipPath = 'inset(0 0 0 ' + Math.max(0, pct) + '%)';
      });
      if (noteEl && noteHtml !== undefined) noteEl.innerHTML = noteHtml;
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () { setCut(parseFloat(b.dataset.cut), b.dataset.note || ''); });
    });
    window.addEventListener('resize', function () {
      var cur = section.querySelector('[data-cut][aria-pressed="true"]');
      if (cur) setCut(parseFloat(cur.dataset.cut), cur.dataset.note || '');
    });

    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var def = section.querySelector('[data-cut][data-default]') || buttons[buttons.length - 1];
        setCut(parseFloat(def.dataset.cut), def.dataset.note || '');
        io.disconnect();
      });
    }, { threshold: 0.2 });
    io.observe(section);
  }

  /* ---------- transparent header over hero ---------- */
  function initHeaderOverlay() {
    var hero = document.querySelector('.xyla-hero[data-overlay-header], .xyla-phead[data-overlay-header]');
    var root = document.documentElement;
    if (!hero) { root.classList.remove('xyla-header-overlay'); return; }
    var header = document.querySelector('.header-wrapper') || document.querySelector('.section-header') || document.querySelector('header');
    if (!header) return;
    var set = function () { root.style.setProperty('--xyla-header-h', header.getBoundingClientRect().height + 'px'); };
    root.classList.add('xyla-header-overlay');
    set();
    window.addEventListener('resize', set);
  }

  function boot() {
    initHeaderOverlay();
    initReveal(document);
    document.querySelectorAll('[data-xyla-bass]').forEach(initBass);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  /* re-init inside Shopify theme editor when a section reloads */
  document.addEventListener('shopify:section:load', function (e) {
    initHeaderOverlay();
    initReveal(e.target);
    e.target.querySelectorAll('[data-xyla-bass]').forEach(initBass);
    e.target.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  });
})();
